// extracted by mini-css-extract-plugin
export default {"input":"PatientStep1_input__qU1ZG","actions":"PatientStep1_actions__bpHe-"};